export var ThirdPartyStatus;
(function (ThirdPartyStatus) {
    ThirdPartyStatus["Active"] = "active";
    ThirdPartyStatus["Archived"] = "archived";
    ThirdPartyStatus["PreContract"] = "pre_contract";
    ThirdPartyStatus["ReviewDue"] = "review_due";
})(ThirdPartyStatus || (ThirdPartyStatus = {}));
//# sourceMappingURL=third-party-status.js.map